import { connect } from 'react-redux'
import { LIST_KEY_ROOT } from '../constants'

import { getListState } from 'data'
import { getListName } from '../../../datasync/fetchesPublicChannelNotes'

const defaultSectionState = {
  isFirstLoading: false,
}

const provideSectionState = connect((state, { item }) => {
  if (item.sectionKey === LIST_KEY_ROOT) {
    return defaultSectionState
  }

  const noteId = item.sectionKey

  const listName = getListName({
    noteId,
  })

  const listState = getListState(listName)(state)

  return {
    isFirstLoading: listState.loading && listState.nodes.length === 0,
  }
})

export default provideSectionState
